<div class="collapsible-schedule py-1 pl-4" [@collapsed]="collapsed" (@collapsed.start)="onCollapsedStarted()"
  (@collapsed.done)="onCollapsedDone()">

  <ng-container *ngIf="renderContent">

    <ng-content></ng-content>

    <table class="collapsible-schedule-table table-sm table-striped border">

      <tbody>
        <tr *ngFor="let row of table">
          <td>
            {{getTimeString(row.hour)}}
          </td>
          <td>
            <ng-container *ngFor="let o of row.items">
              <app-room-schedule-item [scheduleItem]="o" [fromHour]="startHour" [toHour]="endHour"
                (createReservation)="onCreateReservation($event)"></app-room-schedule-item>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>

  </ng-container>
</div>